import { lazy } from 'react';

const TransformerPageCertifiedMaterialConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/transformer/certified-material',
			component: lazy(() => import('./TransformerPageCertifiedMaterial'))
		}
	]
};

export default TransformerPageCertifiedMaterialConfig;